import React from "react";

const ReportsFilters = ({
  filterCategory,
  filterType,
  filterDate,
  filterSubmittedBy,
  uniqueCategories,
  uniqueTypes,
  uniqueSubmittedBy,
  setFilterCategory,
  setFilterType,
  setFilterDate,
  setFilterSubmittedBy,
  resetFilters,
}) => {
  return (
    <div className="d-flex flex-wrap gap-2">
      <select
        className="form-select w-auto"
        value={filterCategory}
        onChange={(e) => setFilterCategory(e.target.value)}
      >
        {uniqueCategories.map((c) => (
          <option key={c} value={c}>
            {c}
          </option>
        ))}
      </select>

      <select
        className="form-select w-auto"
        value={filterType}
        onChange={(e) => setFilterType(e.target.value)}
      >
        {uniqueTypes.map((t) => (
          <option key={t} value={t}>
            {t}
          </option>
        ))}
      </select>

      <input
        type="date"
        className="form-control w-auto"
        value={filterDate}
        onChange={(e) => setFilterDate(e.target.value)}
      />

      <select
        className="form-select w-auto"
        value={filterSubmittedBy}
        onChange={(e) => setFilterSubmittedBy(e.target.value)}
      >
        {uniqueSubmittedBy.map((s) => (
          <option key={s} value={s}>
            {s}
          </option>
        ))}
      </select>

      <button className="btn btn-secondary" onClick={resetFilters}>
        Reset
      </button>
    </div>
  );
};

export default ReportsFilters;
